

import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalEvents from '@/logic/GlobalEvents';

/**
 * Service to acquire and release wake lock
 */
@Component({})
export default class WakeLockService extends Vue {

    private wakelock;

    get enabled() {
        return  this.available && this.$store.getters['settings/getWakeLockEnabled'];
    }

    get available() {
        return this.$store.getters['settings/getWakeLockAvailable'];
    }

    public async acquire() {

        if (this.enabled) {
            // @ts-ignore wakeLock not known to ts
            this.wakelock = await navigator.wakeLock.request('screen');
        }
    }

    public release() {

        if (this.wakelock !== null && this.wakelock !== undefined) {
            this.wakelock.release();
        }
    }

    @Watch('enabled') private onEnabledChange(newVal, oldVal) {
        this.release();
    }

    private mounted() {

        // Test if wakelock is available
        if ('wakeLock' in navigator) {
            this.$store.commit('settings/setWakeLockAvailable', true);
        }

        if (this.available) {

            // Register listeners for keeping wakelock when a performance is active
            GlobalEvents.$on('enter-performance', this.acquire);
            GlobalEvents.$on('leave-performance', this.release);
        }
    }

    // Release wakelock on exiting page
    private beforeDestroy() {

        if (this.available) {
            this.release();
        }
    }
}
